var exports = {
  "kL": "xdbfd91f1--d7b9be--container",
  "DD": "xdbfd91f1--d7b9be--title",
  "p_": "xdbfd91f1--d7b9be--list",
  "x3": "xdbfd91f1--d7b9be--list-item",
  "tb": "xdbfd91f1--d7b9be--list-item_image-container",
  "dK": "xdbfd91f1--d7b9be--list-item_image",
  "yc": "xdbfd91f1--d7b9be--list-item_link",
  "a2": "xdbfd91f1--d7b9be--list-item_address",
  "J8": "xdbfd91f1--d7b9be--list-item_price",
};

module.exports = exports;
